import React from 'react';

import Lozenge from '@atlaskit/lozenge';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';

import messages from '../messages.tsx';

export const PaidFeatureAwarenessStandardLozenge = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Tooltip content={formatMessage(messages.standardTooltip)}>
			<Lozenge appearance="new">{formatMessage(messages.standardLozenge)}</Lozenge>
		</Tooltip>
	);
};

export const PaidFeatureAwarenessPremiumLozenge = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Tooltip content={formatMessage(messages.premiumTooltip)}>
			<Lozenge appearance="new">{formatMessage(messages.premiumLozenge)}</Lozenge>
		</Tooltip>
	);
};
